export const getMinutesAndSeconds = numSeconds => {
  const minutes = Math.floor(numSeconds / 60);
  const seconds = numSeconds - minutes * 60;
  return { minutes, seconds };
};

export const getHumanReadableDuration = numSeconds => {
  const time = getMinutesAndSeconds(numSeconds);
  let humanReadable = '';
  if (time.minutes) {
    humanReadable += `${time.minutes}m`;
  }
  if (time.seconds) {
    humanReadable += ` ${time.seconds}s`;
  }

  return humanReadable;
};

export const getHumanReadableDurationFull = numSeconds => {
  const time = getMinutesAndSeconds(numSeconds);

  let humanReadable = '';
  if (time.minutes > 1) {
    humanReadable += `${time.minutes} minutes `;
  } else if (time.minutes && time.minutes < 2)
    humanReadable += `${time.minutes} minute `;
  if (time.seconds > 1) {
    humanReadable += `${time.seconds} seconds`;
  } else if (time.seconds && time.seconds < 2) {
    humanReadable += `${time.seconds} second`;
  }

  return humanReadable.trim();
};

export const getColonSeparatedDuration = numSeconds => {
  const time = getMinutesAndSeconds(numSeconds);
  function str_pad_left(string, pad, length) {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  }

  return `${time.minutes}:${str_pad_left(time.seconds, '0', 2)}`;
};

export const guid = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const validateBotResponse = message => {
  try {
    JSON.parse(message);
    return 'no-error';
    // Todo: Add validations for Valid HSL
  } catch (SyntaxError) {
    // Invalid JSON
    if (/^{chatform}{[0-9]+}$/.test(message)) {
      // This is a chatform. Throw Warnings
      return 'warning';
    } else if (/^{link}{.+}$/.test(message)) {
      // This is a link. Throw warnings
      return 'warning';
    } else if (message.includes('{') || message.includes('}')) {
      // Throw errors if it has '{' or '}' indicating a malformed or
      // deprecated non-HSL message
      return 'error';
    } else if (!message) {
      // Empty message. No error/warning etc.
      return 'empty';
    }
    // Valid Plain text message. All OK.
    return 'no-error';
  }
};
